import React from "react";

const RemoveMemberModal = ({
  removeMemberModal,
  onClose,
  onConfirm,
}) => {
  if (!removeMemberModal.open) return null;

  const memberName =
    `${removeMemberModal.member?.firstName || ""} ${
      removeMemberModal.member?.lastName || ""
    }`.trim() || "this member";

  return (
    <div className="fixed inset-0 bg-slate-900/50 z-[140] flex items-center justify-center p-4 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-6 animate-in zoom-in-95 duration-200 border border-gray-100 text-center">
        <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center text-xl mx-auto mb-4">
          <i className="fa-solid fa-user-xmark"></i>
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-1">Remove Member?</h3>
        <p className="text-xs text-gray-500 mb-6 leading-relaxed">
          Remove{" "}
          <span className="font-bold text-gray-800">{memberName}</span>{" "}
          from the study group? They will lose access to shared notes and chat.
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl font-bold text-xs text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(removeMemberModal.member)}
            className="flex-1 py-2.5 rounded-xl font-bold text-xs text-white bg-red-600 hover:bg-red-700 transition shadow-sm"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveMemberModal;
